import { IApiError } from '@/models/apiError.model';
import { IGetBidsListResponse } from '@/models/bidding.model';

export const BIDDING_SLICE_NAME = 'bidding';

export interface BiddingState {
  bidsList: IGetBidsListResponse | null;
  propertyId: string | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: BiddingState = {
  bidsList: null,
  propertyId: null,
  isLoading: false,
  error: null,
};
